import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {ClientContactsModel} from "./client-contacts.model";
import {Injectable} from "@angular/core";

@Injectable()
export class ClientContactsService implements IDataModel {

    private API_ROOT:string = '/clients/contacts';

    constructor(private http:Http) {
    }

    getList(filter:IDataFilter): Observable<ListResponseModel<ClientContactsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<ClientContactsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/contacts`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    saveList(clientId:number, owners: ClientContactsModel[]): Observable<ListResponseModel<ClientContactsModel>> {
        return this.http.put(`/clients/${clientId}/contacts`, owners)
            .map((res) => {
                let response: ListResponseModel<ClientContactsModel> = res.json();
                return response;
            });
    }

    getOne(id:number):Observable<ResponseModel<ClientContactsModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:ClientContactsModel): Observable<ResponseModel<ClientContactsModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:ClientContactsModel): Observable<ResponseModel<ClientContactsModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/client-contacts/client-contacts.service.ts